// IBM Plex Sans and Mono for the screens that use them (the BOM import preview first). One place, so the
// whole app can move to it by changing the theme's font family.
// apps/smart-catalog/frontend/src/theme/ibmPlex.ts

import { useEffect } from 'react';
import { createTheme, type Theme } from '@mui/material/styles';

export const IBM_PLEX_SANS = '"IBM Plex Sans", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif';
export const IBM_PLEX_MONO = '"IBM Plex Mono", ui-monospace, SFMono-Regular, Menlo, monospace';
const FONT_HREF = 'https://fonts.googleapis.com/css2?family=IBM+Plex+Sans:wght@400;500;600;700&family=IBM+Plex+Mono:wght@400;500&display=swap';

/** Loads the face once per page; the module federation host may not carry it. */
export function useIbmPlexFont(): void {
  useEffect(() => {
    if (document.querySelector(`link[href="${FONT_HREF}"]`)) return;
    const link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = FONT_HREF;
    document.head.appendChild(link);
  }, []);
}

/** The surrounding theme with IBM Plex Sans as its font. */
export const withIbmPlex = (outer: Theme): Theme => createTheme(outer, { typography: { fontFamily: IBM_PLEX_SANS } });
